import { signal } from '@angular/core';

const open = signal(false);

/**
 * Whether the import dialog is on screen. The realtime handlers read it to skip
 * the "completed" toast while the dialog is already showing that outcome.
 */
export const importDialogOpen = open.asReadonly();

/** Called by the dialog itself, on open and on close. */
export function setImportDialogOpen(isOpen: boolean): void {
  open.set(isOpen);
}
